<template>
  <div>
    <dropdownButton
      class="export-excel-div width-fit-content"
      :classButton="getClassButton"
      :actions="secondaryActions"
      :type="type"
      @click="exportAction(query)">
      <b-icon
        icon="database-export"
        size="is-small">
      </b-icon>
      <span class="is-size-7">
        {{$t('general.button.export')}}
      </span>
    </dropdownButton>
    <a ref="lienDownloadExportExcel"></a>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import exportExcel from '@/api/exportExcel';
import inProgress from '@/services/general/inProgress';
import dropdownButton from '@/components/general/button/dropdownButton';

const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    perm: {
      type: Object,
      required: true,
    },
    query: {
      type: Object,
      required: false,
      default: () => {},
    },
    inProgress: {
      type: Boolean,
      required: false,
      default: false,
    },
    action: {
      type: Function,
      required: false,
      default: null,
    },
    errorManager: {
      type: Function,
      required: false,
      default: null,
    },
    errors: {
      type: Array,
      required: false,
      default: () => [],
    },
    secondaryExports: {
      type: Array,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: 'is-white',
    },
  },
  components: {
    dropdownButton,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    secondaryActions() {
      if (this.secondaryExports && this.secondaryExports.length > 0) {
        const actions = this.secondaryExports.map((exportItem) => {
          if (exportItem.action) {
            return {
              label: exportItem.libelle,
              action: exportItem.action,
              order: exportItem.id,
            };
          }
          if (exportItem.query) {
            return {
              label: exportItem.libelle,
              action: () => { this.exportAction(exportItem.query, false); },
              order: exportItem.id,
            };
          }
          return {
            label: exportItem.libelle,
            action: () => {},
            order: exportItem.id,
          };
        });
        return actions;
      }
      return [];
    },
    getClassButton() {
      const classButton = 'mgb-0 export-excel-button';
      return this.checkPermissions(this.perm) ? `has-text-link ${classButton}` : `button-access-no-permission ${classButton}`;
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async exportAction(query, isMainAction = true) {
      if (!this.checkPermissions(this.perm)) {
        this.showPopUp();
        return;
      }
      if (this.inProgress && isMainAction) {
        inProgress(this.$i18n, null);
        return;
      }
      if (this.action && isMainAction) {
        this.action();
        return;
      }
      await this.exportToExcel(query);
    },
    async exportToExcel(query) {
      this.$emit('update:errors', []);
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await exportExcel(query);
        const link = this.$refs.lienDownloadExportExcel;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        if (this.errorManager) this.errorManager(e);
        else messageErreur(this.$i18n, this.$i18n.t('general.messages.error.excelError'));
        loadingComponent.close();
        throw e;
      }
    },
  },
};
</script>

<style>

</style>
